import { IRouteProps } from '@cap/ssr-common-utils/types';
import loadable from '@loadable/component';

export const videoRouter: IRouteProps[] = [
  {
    path: '/video/:id/:chapterId?',
    name: 'video',
    component: loadable(() => import('./index')),
  },
];
